import Mapper from './Mapper';
import { OrderReportConfigResponseDTO } from 'typings/dto/orderReport';
import DIContainer from 'services/DIContainer';

export default class OrderReportConfigMapper extends Mapper<OrderReportConfig, OrderReportConfigResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      name: 'name',
      technicalName: 'technicalName',
      description: 'description',
      tenant: 'tenant',
      fields: 'fields',
      onSubmitAction: 'onSubmitAction',
    });
  }

  public responseDTOToModel(dto: OrderReportConfigResponseDTO): OrderReportConfig {
    const outerMappers = this.getOuterMappers();
    const fieldsMapped = dto.fields.map((item) => this.subEntitiesMappers.dynamicField.responseDTOToModel(item, outerMappers));

    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      fields: fieldsMapped,
    };
  }
}
